import { AnoBase } from './ano-base.model';
import { Regiao } from './regiao.model';
import { TipoParametro } from './tipo-parametro.model';

export class Parametrizacao {

  id: number;
  regiao: Regiao;
  anoBase: AnoBase;
  tipoParametro: TipoParametro;
  valor: number;

  constructor(init?: Partial<Parametrizacao>) {
    Object.assign(this, init);
  }


}
